import styled, { css } from 'styled-components';

const applyDefaults = (defaults, templateFunc) => (props) =>
  templateFunc({ ...defaults, ...props });

const flexboxTemplateFunc = ({
  flexDirection,
  justifyContent,
  alignItems,
  flex = 1,
  textAlign,
}) => css`
  flex: ${flex};
  ${flexDirection &&
    css`
      flex-direction: ${flexDirection};
    `}
  ${justifyContent &&
    css`
      justify-content: ${justifyContent};
    `}
  ${alignItems &&
    css`
      align-items: ${alignItems};
    `}
  ${textAlign &&
    css`
      text-align: ${textAlign};
    `}
`;

export const FlexBox = styled.div`
  ${flexboxTemplateFunc}
  display: flex;
`;

// use inside of a flex layout, but do nothing
export const FlexLayout = styled(FlexBox)`
  ${applyDefaults(
    {
      flex: 'none',
    },
    flexboxTemplateFunc,
  )}
`;

export const FlexLayoutRow = styled(FlexBox)`
  ${applyDefaults(
    {
      flex: 'none',
      flexDirection: 'row',
    },
    flexboxTemplateFunc,
  )}
`;

export const FlexLayoutColumn = styled(FlexBox)`
  ${applyDefaults(
    {
      flex: 'none',
      flexDirection: 'column',
    },
    flexboxTemplateFunc,
  )}
`;

export const FlexBoxCentered = styled(FlexBox)`
  ${applyDefaults(
    {
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    },
    flexboxTemplateFunc,
  )}
`;

export const FlexBoxCenteredColumn = styled(FlexBoxCentered)`
  ${applyDefaults(
    {
      flexDirection: 'column',
    },
    flexboxTemplateFunc,
  )}
`;

export const FlexBoxCenteredRow = styled(FlexBoxCentered)`
  ${applyDefaults(
    {
      flexDirection: 'row',
    },
    flexboxTemplateFunc,
  )}
`;
